import Api from "@/services/AxiosAPI";

export default {
  login(email, password) {

    const post = new FormData();
    post.append("email", email);
    post.append("password", password);

    return Api.postData('login', post)
      .then(responses => {
        return responses
      });


  },
  mycourses(user_id, customer_id) {
    let customerUrlParam = ( customer_id ) ? '/' + customer_id : '';
    return Api.getData('mycourses/' + user_id + customerUrlParam)
      .then(responses => {
        return responses
      });
  },
  getlink(link) {

    return Api.getData(link)
      .then(responses => {
        return responses
      });
  },
  delegate(customer_id) {
    return Api.getData('delegate-certificates/' + customer_id)
      .then(responses => {
        return responses
      });

  },
  orderview(id) {
    return Api.getData('accounts/orderinfo/' + id)
      .then(responses => {
        return responses
      });
  },
  regsiter(email) {

    const post = new FormData();
    post.append("email", email);
    return Api.postData('user', post)
      .then(responses => {
        return responses
      });


  },
  orderhistory(customer_id) {

    return Api.getData('user-orders/' + customer_id)
      .then(responses => {
        return responses
      });

  },
  cataloguerequest(customer_id, catalog) {


    //var json_catalog = JSON.stringify(catalog);
    // console.log(catalog);return false;
    // const post = {
    //   catalogs: catalog
    // };
    let formdata = {
      catalogs: catalog
    };

    return Api.postData('catalogue-request/' + customer_id, formdata)
      .then(responses => {
        return responses
      });

  },
  cataloguecheck(customer_id) {

    return Api.getData('catalogues/' + customer_id)
      .then(responses => {
        return responses
      });

  },
  download(customer_id) {
    const post = new FormData();
    if(customer_id) 
        post.append("user_id", customer_id);
    return Api.postData('downloads', post)
      .then(responses => {
        return responses
      });

  },

  savedelegates(auth, customer_id, slug, traineeArray) {


    var myJSON  = JSON.stringify(traineeArray);
    var mySlugs = JSON.stringify(slug);
    const post = new FormData();
    post.append("slug", mySlugs);
    post.append("traineeArray", myJSON);
    return Api.postData('save-delegates/' + auth + '/' + customer_id, post)
      .then(responses => {
        return responses
      });


  },
  checkemail(email) {
    const post = new FormData();
    post.append("email", email);
    return Api.postData('checkuser', post)
      .then(responses => {
        return responses
      });
  },
  checkprice(cart) {
    var carts = JSON.stringify(cart);
    const post = new FormData();
    post.append("products", carts);
    return Api.postData('checkProductsPrice', post)
      .then(responses => {
        return responses.data
      });
  },
  forgot(email) {
    //var carts = JSON.stringify(cart);
    const post = new FormData();
    post.append("email", email);
    return Api.postData('request-password', post)
      .then(responses => {
        return responses.data
      });
  },
  resetpassword(credentialsObj, token) {
    //var carts = JSON.stringify(cart);
    const post = new FormData();
    post.append("emailInput", credentialsObj.email);
    post.append("passwordToken", token);
    post.append("newPassword", credentialsObj.confirmPassword);
    return Api.postData('reset-password', post)
      .then(responses => {
        return responses.data
      });
  },

  getuserdetails(customerid) {
    return Api.getData('users/' + customerid)
      .then(responses => {
        return responses.data
      });
  },

  gethcruserdetails(userid) {
    return Api.getData('hcr-user/' + userid)
      .then(responses => {
        return responses.data
      });
  },
  getdeliverydetails(customerid) {

    return Api.getData('consignee/' + customerid)
      .then(responses => {
        return responses.data
      });


  },
  changepassword(pass, auth) {
    const post = new FormData();
    // post.append("currentPassword", pass.epassword);
    post.append("newPassword", pass.password);
    post.append("userId", auth);
    return Api.postData('change-password', post)
      .then(responses => {
        return responses
      });

  },
  updatedelivery(data, auth) {
    return Api.postData('consignee', data)
      .then(responses => {
        return responses
      });

  },
  usercredits(auth, customer_id) {
    return Api.getData('user-credits/' + auth + '/' + customer_id)
      .then(responses => {
        return responses
      });

  },
  usercreditsform(auth, customer_id, slug) {

    return Api.getData('user-credits-form/' + slug + '/' + auth + '/' + customer_id)
      .then(responses => {
        return responses
      });

  },
  updateDetails(user, userid) {
    return Api.postData('/user/' + userid, {
      'first_name': user.first_name, 'first_name': user.first_name,
      'last_name': user.last_name, 'address_1': user.address_1, 'address_2': user.address_2, 'address_3': user.address_3,
      'address_4': user.address_4, 'town': user.town, 'country_id': user.country_id, 'postcode': user.postcode, 'mobile_phone': user.mobile_phone,
      'phone': user.phone, 'company_name': user.company_name, 'county': user.county, 'subscription': user.subscription, 'courtesy_title': user.courtesy_title,
      'fax': user.fax
    })
      .then(response => {
        return response.data
      });
  },
  updateHcrDetails(user,userid) {
    return Api.postData('/hcr-user/'+userid, { 'name': (user.first_name+' '+user.last_name).trim() })
            .then(response => {
              return response.data
            });     
    },
  getcountry() {
    return Api.getData('country-list')
      .then(responses => {
        return responses
      });

  },
}
